import React, { useCallback, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import CancelIcon from "@mui/icons-material/Cancel";
import toast from "react-hot-toast";
import SingleImageUpload from "../../../../../components/UploadImage/UploadImage";
import { uploadImageClubAPI } from "../../../../../services/rest/runningsClubs/runningClubsProviderService";
import { getGalleryClubAPI } from "../../../../../services/rest/runningsClubs/runningClubUser";
import { handleError } from "../../../../../utils/handleError";

const ModalUploadImageClub = ({
  open,
  selectedRunningClub,
  setShowModalAddImage,
  setLoading,
  setGalleryList,
}) => {
  const [imageSelected, setImageSelected] = useState(null);
  const handleClose = useCallback(() => {
    setShowModalAddImage(false);
  }, [setShowModalAddImage]);
  const handleImageChange = (imageFile) => {
    // console.log("Imagen seleccionada:", imageFile);
    setImageSelected(imageFile);
  };
  const uploadImage = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      if (imageSelected) {
        formData.append("img", imageSelected);
      }
      // console.log(formData);
      //Se hace la peticion a la API de update galeria de  comunidad y se hace peticion a la API de mis comunidades y se actualiza redux communitiesOfProvider
      await uploadImageClubAPI(selectedRunningClub?._id, formData);
      const responseGallery = await getGalleryClubAPI(selectedRunningClub?._id);
      setGalleryList(responseGallery ?? []);
      handleClose();
      toast.success("Se Subio la imagen correctamente.");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const { message } = handleError(error);
      toast.error(
        `En estos momentos no se puede subir la imagen a la comunidad. \n ${message}`
      );
    }
  };
  return (
    <Dialog open={open}>
      <DialogContent sx={{ padding: 5 }}>
        <DialogTitle>
          <Typography sx={{ textAlign: "center" }}>
            Subir imagen a {selectedRunningClub?.nameRunningClub}
          </Typography>
        </DialogTitle>
        <SingleImageUpload onImageChange={handleImageChange} />
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="outlined"
            sx={{ borderColor: "white", color: "white" }}
            startIcon={<AddPhotoAlternateIcon />}
            onClick={uploadImage}
          >
            Guardar imagen
          </Button>
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{ backgroundColor: "#e7ef7d" }}
            startIcon={<CancelIcon />}
          >
            Cerrar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ModalUploadImageClub;
